import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrgChartHr } from 'routes/HumanResourcesModule/PayState/helpers/types';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import Flex from 'ui/Flex/Flex';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/components/Modals/helpers/dataHelpers';
import OrgChartHrSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/components/selectors/OrgChartHrSelector';
import MantyStatusSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/components/selectors/MantyStatusSelector';

type Props = {
    orgChartHrs: OrgChartHr[];
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
    nonRecurrentMantyStatuses: MantyStatus[];
};

const NewHypothesisForm = ({
    formState,
    setFormState,
    orgChartHrs,
    nonRecurrentMantyStatuses,
}: Props) => {
    const { t } = useTranslation();

    return (
        <Flex
            flexDirection="column"
            sx={{
                marginTop: '1em',
                gap: '2em',
            }}
        >
            <OrgChartHrSelector
                orgChartHrs={orgChartHrs}
                formState={formState}
                setFormState={setFormState}
            />

            <MantyStatusSelector
                value={formState.mantyStatus}
                formState={formState}
                setFormState={setFormState}
                label={t('humanResources.simulation.addAgent.mantyStatus')}
                dataList={nonRecurrentMantyStatuses}
            />
        </Flex>
    );
};

export default NewHypothesisForm;
